angular.module("vgresiduos").factory("clientVersionHeaderInjector", [
	function () {
		"use strict";

		// BackendV2 (newHostUrl) só aceita headers listados em Access-Control-Allow-Headers do Web.config
		const apiHosts = [
			Vgr.constants.newHostUrl,
			Vgr.constants.coreHostUrl,
			Vgr.constants.sharedServicesHostUrl,
			Vgr.constants.residuesManagementHostUrl,
			Vgr.constants.suppliersHostUrl,
			Vgr.constants.residuesHostUrl,
			Vgr.constants.integrationsHostUrl
		];

		function isApiRequest(url) {
			return apiHosts.some(function (host) {
				return url.indexOf(host) === 0;
			});
		}

		return {
			request: function (config) {
				if (config && config.url && isApiRequest(config.url)) {
					config.headers["X-Client-Version"] = Vgr.constants.clientVersion.build;
					config.headers["X-Client-Contract"] = String(Vgr.constants.clientVersion.contract);
				}
				return config;
			}
		};
	}
]);
